import React from 'react';
import DescriptionField from '../../fields/DescriptionField';
import { FormInputCheckbox } from 'folksam-ui';

/**
 * This is a modifed version of the core widget
 * See https://github.com/mozilla-services/react-jsonschema-form/blob/v1.2.0/src/components/widgets/CheckboxWidget.js
 */
const CheckboxWidget = ({ schema, id, value, required, disabled, readonly, label, autofocus, onChange }) => {
  return (
    <div>
      {schema.description && <DescriptionField description={schema.description} />}
      <FormInputCheckbox
        id={id}
        name={id}
        label={label}
        checked={typeof value === 'undefined' ? false : value}
        required={required}
        disabled={disabled || readonly}
        autoFocus={autofocus}
        value={value.toString()}
        onChange={event => onChange(event.target.checked)}
      />
    </div>
  );
};

CheckboxWidget.defaultProps = {
  autofocus: false
};

export default CheckboxWidget;
